import api from "./api";

export const requestValeuReview = async (data) => {
    return await api.post(`/email/review`, data);
}


export const updateReceipt = async (processID, financial) => {
    return api.patch(`cargoprocesses/${processID}/receipt`, financial)
}